import React, { Fragment } from 'react';
import { render } from 'react-dom';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router } from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';

import GlobalData from 'components/providers/global-data/provider';

import client from './apollo';
import App from './App';
import theme from './theme';
import GlobalStyle from './global-style';

const rootElement = document.getElementById('app');

render(
  <ApolloProvider client={client}>
    <ThemeProvider theme={theme}>
      <Router>
        <GlobalData>
          <Fragment>
            <App />
            <GlobalStyle />
          </Fragment>
        </GlobalData>
      </Router>
    </ThemeProvider>
  </ApolloProvider>,
  rootElement,
);
